<template>
    <div class="heading-tabs" :class="{ 'is-on-background-app': isOnBackgroundApp }">
        <template v-if="type === 'vuerouter'">
            <router-link
                v-for="link in tabs"
                :key="link.name"
                :to="{ name: link.name }"
                class="heading-tabs__link typographies-paragraph-medium-semibold"
                activeClass="heading-tabs__link--is-active"
                exact
            >
                {{ link.label }}
            </router-link>
        </template>
        <template v-else>
            <div
                v-for="tab in tabs"
                :key="tab.id"
                class="heading-tabs__link typographies-paragraph-medium-semibold"
                :class="{ 'heading-tabs__link--is-active': tab.id === activeTab }"
                @click="$emit('tab-clicked', tab.id)"
            >
                {{ tab.label }}
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: 'vuerouter',
            validator: function (value) {
                return ['vuerouter', 'filter'].includes(value);
            },
        },
        tabs: {
            type: Array,
            required: true,
        },
        activeTab: {
            type: String,
            default: null,
        },
        isOnBackgroundApp: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.heading-tabs {
    display: flex;
    gap: var(--spacing-1);

    &__link {
        border-radius: var(--spacing-0);
        color: var(--colors-component-text-navigation-hover-alt);
        padding: 6px var(--spacing-1);
        cursor: pointer;

        &:hover:not(&--is-active) {
            background: var(--colors-common-background-colored-hover);
        }

        &--is-active {
            background: var(--colors-component-background-navigation-active-default-alt);
            color: var(--colors-component-text-navigation-active-default);
        }
    }

    &.is-on-background-app {
        .heading-tabs__link {
            color: var(--colors-component-text-navigation-hover-alt);

            &:hover:not(.heading-tabs__link--is-active) {
                background: var(--colors-common-background-colored-hover);
            }

            &--is-active {
                background: var(--colors-component-background-navigation-active-default-alt);
                color: var(--colors-component-text-navigation-hover-alt);
            }
        }
    }
}
</style>
